import React from 'react';
import { createIcon } from './create-icon';
import './icon-logout.scss';

export const IconLogout = createIcon(<div className="icon-logout" />);
